declare namespace $ {

	export class $mol_icon_chart_line extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=line.view.tree.d.ts.map